// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1zpMF","content":"styles_content__1HYqb"};